import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { loadBrand } from "@/lib/brand";

// /c/{slug}/rest → remembers the company's preview path for this tab, then opens /rest on that company's portal.
export default function CompanyPath() {
  const { slug, "*": rest } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    sessionStorage.setItem("company_path", slug);
    loadBrand(true);
    navigate(`/${rest || "login"}`, { replace: true });
  }, [slug, rest, navigate]);
  return null;
}
